<div class="rs-barchart" data-rslib-css-load="rslib.css.barchart">
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column rs-order-s2 text-center">
      <p
        id="ac-barchart-table1bar"
        class="rs-font-pxB"
        data-cy="evolutionChartTitle"
      >
        {{ chartTitle }}
      </p>
    </div>
    <div *ngIf="isMobile" class="rs-flex-column rs-flex-shrink rs-order-s3">
      <div class="rs-navigation rs-block">
        <div
          (click)="handleArrowClick('next')"
          class="rs-navigation-arrow rs-navigation-arrow-next"
          [ngClass]="{ 'rs-disabled': isNextArrowDisabled }"
          data-cy="nextButton"
        >
          <button
            class="rs-navigation-trigger"
            attr.aria-label="{{
              'bills.evolutionChart.web.nextMonths' | translate
            }}"
          >
            <i
              class="icon-Arrowbutton icon-lh icon-large"
              attr.aria-label="{{
                'bills.evolutionChart.web.nextMonths' | translate
              }}"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="isMobile" class="rs-flex-column rs-flex-shrink rs-order-s1">
      <div class="rs-navigation rs-block">
        <div
          (click)="handleArrowClick('previous')"
          class="rs-navigation-arrow rs-navigation-arrow-prev"
          [ngClass]="{ 'rs-disabled': isPreviousArrowDisabled }"
          data-cy="previousButton"
        >
          <button
            class="rs-navigation-trigger"
            attr.aria-label="{{
              'bills.evolutionChart.web.previousMonths' | translate
            }}"
          >
            <i
              class="icon-Arrowbutton-left icon-lh icon-large"
              attr.aria-label="{{
                'bills.evolutionChart.web.previousMonths' | translate
              }}"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <p class="rs-txt-s3 text-right rs-padding-bottom1" data-cy="maximumValue">
    <span class="show-for-sr"
      >{{ 'bills.evolutionChart.web.maximumValue' | translate }}
    </span>
    <px-currency-amount [amount]="maxAmount?.toString()"></px-currency-amount>
  </p>

  <div class="rs-barchart-content">
    <table class="rs-barchart-graph" aria-labelledby="ac-barchart-table1bar">
      <thead class="show-for-sr">
        <tr>
          <th scope="col">
            {{ 'bills.evolutionChart.web.month' | translate }}
          </th>
          <th scope="col">
            {{ 'bills.evolutionChart.web.billValue' | translate }}
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container
          *ngFor="let item of displayedChartData; index as itemIndex"
        >
          <tr
            class="jsrs-clickable rs-clickable"
            [ngClass]="{ 'rs-barchart-selected': item.isSelected }"
            (click)="selectChartItem(itemIndex, true)"
          >
            <th scope="row">
              <button
                type="button"
                [attr.aria-expanded]="item.isSelected"
                [attr.aria-controls]="'ac-panel-1bar-' + itemIndex"
                [attr.data-cy]="'month-' + itemIndex"
              >
                {{ getMonthLabel(item.date.split('/')[1]) }}
              </button>
            </th>

            <td
              *ngIf="item.positivePercentage"
              class="rs-barchart-color-blue"
              [style.height.%]="item.positivePercentage"
            >
              <span class="show-for-sr">{{ item.positiveAmount }}€</span>
            </td>
            <td
              *ngIf="item.negativePercentage"
              class="rs-barchart-color-magenta"
              [style.height.%]="item.negativePercentage"
            >
              <span class="show-for-sr">{{ item.negativeAmount }}€</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="rs-barchart-zero"></div>
  </div>
</div>
